import $ from 'jquery';
import 'slick-carousel';

const ResultSlider = () => {

	let resultSlider = $('#resultstable');

	resultSlider.slick({
		accessibility: false,
		arrows: true,
		adaptiveHeight: false,
		dots: false,
		draggable: true,
		fade: true,
		infinite: false,
		mouseDrag: false,
		slidesToShow: 1,
		slidesToScroll: 1,
        prevArrow: '',
        nextArrow: '.all-results__next'
	});

	const result_select = document.querySelector('[data-result-select]');

	if (typeof result_select != "undefined" && result_select != null) {
		
		result_select.addEventListener('change', () => {

			if (typeof result_select.value != "undefined" && result_select.value != null) {
				selectSlide(result_select.value);
			}

		});

        resultSlider.on('afterChange', function(event, slick, currentSlide){
            result_select.value = currentSlide;
        });
	}

	const recent_button = document.querySelector('[data-recent-button]');

    if (typeof recent_button != "undefined" && recent_button != null) {

        recent_button.addEventListener('click', (e) => {

            e.preventDefault();
            result_select.value = recent_button.getAttribute('data-recent-button');
            goToZero();
            
        });
    }

	function selectSlide(slide_id) {
            
        if (slide_id) {
            resultSlider.slick('slickGoTo', slide_id);
        } else {
            goToZero();
        }
	}

	function goToZero() {
		resultSlider.slick('slickGoTo', 0);
	}
};

export default ResultSlider;